import { PREPARE_CHECKOUT_REQUEST, PREPARE_CHECKOUT_SUCCESS, PREPARE_CHECKOUT_ERROR } from '../types';
import { useHelper } from '../helpers';
export const prepareCheckoutRequest = () => {
  return {
    type: PREPARE_CHECKOUT_REQUEST
  };
};
export const prepareCheckoutSuccess = _ref => {
  let {
    cart,
    products
  } = _ref;
  return {
    type: PREPARE_CHECKOUT_SUCCESS,
    data: cart,
    products
  };
};
export const prepareCheckoutError = error => {
  return {
    type: PREPARE_CHECKOUT_ERROR,
    error: true,
    payload: error
  };
};
export const prepareCheckout = options => {
  return async (dispatch, getState, _ref2) => {
    let {
      chord
    } = _ref2;
    const {
      withCart
    } = useHelper(dispatch, getState);
    dispatch(prepareCheckoutRequest());
    try {
      const updatedCart = await withCart(chord.oms.prepareCheckout)();
      dispatch(prepareCheckoutSuccess({
        cart: updatedCart,
        products: options?.products
      }));
      return updatedCart;
    } catch (error) {
      dispatch(prepareCheckoutError(error));
      throw error;
    }
  };
};